import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

/* Op de BODY data: {controller: timeout'', timeout_period_value: Devise.timeout_in} 
  Toch werkt dat hier niet goed. Door Rails Turbo en lazy loading, is de timer al lang gestart, 
  terwijl er nog GET requests plaats vinden om het scherm te vullen. 
  Bovendien moet je dit uitzetten als 'Ingelogd blijven' aangevinkt staat.
*/
export default class extends Controller {
  static values = {
    period: Number    // timeout in Seconds
  }

  connect() {
    // console.log("Hello, Timeout!", this.element);

    // Do this instead
    setTimeout(() => {
      console.log(`Timeout after ${this.periodValue} seconds`);

      // First, look for any open Modal to close it
      const currentModalElm= document.querySelector('.modal.show');
      if (currentModalElm) {
        let modal = bootstrap.Modal.getOrCreateInstance(currentModalElm, {});
        if (modal) modal.hide();
      }

      // Now, open the Timeout modal
      const modalElm= document.querySelector('#timeout_modal')
      const modalOptions={};

      let modal = bootstrap.Modal.getOrCreateInstance(modalElm, modalOptions);
      if (modal) {
        modal.show();
      }
    }, this.periodValue * 1000);

  }
}
